'use strict';

class invoiceService {
  constructor($http) {
    this.$http = $http;
  }

  getDecisionList(page, perPage) {
    return this.$http.get(`/invoices/decisions?page=${page}&perPage=${perPage}`);
  }

  listCreditable(params = {}) {
    return this.$http.get(`/invoices/creditable`, {
      params: params
    });
  }

  get(number) {
    return this.$http.get(`/invoices/${number}`);
  }

  getByKid(number) {
    return this.$http.get(`/invoices/kid/${number}`);
  }

  massCredit(params = []) {
    return this.$http.post(`/invoices/send-credit-notes`, params);
  }

  massDeleteDrafts(params = []) {
    return this.$http.post(`/invoices//drafts/mass-delete`, params);
  }

  getTaxRates(number) {
    return this.$http.get(`/invoices/${number}/taxRates`);
  }

  statistics() {
    return this.$http.get(`/invoices/statistics`);
  }

  send(params, timeTrackNumber) {
    if (timeTrackNumber) {
      return this.$http.post(`/invoices/?timeTrackNumber=${timeTrackNumber}`, params);
    } else {
      return this.$http.post(`/invoices/`, params);
    }
  }

  sendAgain(number, params) {
    return this.$http.post(`/invoices/${number}/send`, params);
  }

  /* DRAFTS */
  saveDraft(data) {
    return this.$http.post(`/invoices/drafts`, data);
  }

  getDraft(number) {
    return this.$http.get(`/invoices/drafts/${number}`);
  }

  fetchLastInvoiceForRecipient(number) {
    return this.$http.get(`/invoices/recipient/${number}/last`);
  }

  getDraftFromTemplate(number) {
    return this.$http.get(`/invoices/drafts/template/${number}`);
  }

  getDraftFromTimeTrack(number) {
    return this.$http.get(`/invoices/drafts/timetrack/${number}`);
  }

  updateDraft(number, params) {
    return this.$http.put(`/invoices/drafts/${number}`, params);
  }

  deleteDraft(number) {
    return this.$http.delete(`/invoices/drafts/${number}`);
  }

  /* IDENTICAL */
  getIdenticalInvoices(params = {}) {
    return this.$http.get(`/identical/withCount`, {
      params: params
    });
  }

  getIdenticalInvoice(number) {
    return this.$http.get(`/identical/${number}`);
  }

  getIdenticalInvoiceStatus(number) {
    return this.$http.get(`/identical/${number}/status`);
  }
  getIdenticalInvoiceStatusForAll() {
    return this.$http.get(`/identical/status/all`);
  }

  getIdenticalRecipients(number) {
    return this.$http.get(`/identical/${number}/recipients`);
  }

  getFailedIdenticalInvoices(number) {
    return this.$http.get(`/identical/${number}/failures`);
  }

  sendIdenticalInvoice(params) {
    return this.$http.post(`/identical/`, params, {
      headers: {
        Prefer: 'respond-async'
      }
    });
  }

  /* COLLECTION */
  getCollectionCases(number) {
    return this.$http.get(`/collection/cases/${number}`);
  }

  sendToDebtCollection(number) {
    return this.$http.post(`/invoices/${number}/debt-collection`);
  }

  registerCreditor(params) {
    return this.$http.post(`/invoices/debt-collection/creditor`, params);
  }
}

invoiceService.$inject = ['$http'];

angular
  .module('SendRegning')
  .service('invoiceService', invoiceService);
